import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import ImageWithBasePath from "../../core/data/img/ImageWithBasePath";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { testimonialsData } from "../../core/data/json/testimonials_data";
import { all_routes } from "../router/all_routes";

const Home = () => {
  const routes = all_routes;
  const testimonials = testimonialsData;

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  useEffect(() => {
    AOS.init({ duration: 1200, once: true });
  }, []);

  return (
    <>
      <Helmet>
        <title>Eleego Luxury Car Rental & Chauffeur Services Switzerland</title>
        <meta name="description" content="Discover luxury & elegance with our premier Limousine and rental service in Switzerland. VIP mobility, chauffeur services, and premium rentals." />
        <meta property="og:title" content="Eleego Luxury Car Rental & Chauffeur Services" />
        <meta property="og:description" content="Discover luxury & elegance with our premier Limousine and rental service in Switzerland. VIP mobility, chauffeur services, and premium rentals." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://eleego.ch/" />
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "AutoRental",
              "name": "Eleego Luxury Car Rental & Chauffeur Services",
              "url": "https://eleego.ch/",
              "description": "Discover luxury & elegance with our premier Limousine and rental service in Switzerland. VIP mobility, chauffeur services, and premium rentals.",
              "address": {
                "@type": "PostalAddress",
                "addressCountry": "CH"
              }
            }
          `}
        </script>
      </Helmet>
      {/* Banner */}
      <div className="lux-hero imageOne">
        <div className="container">
          <div className="lux-hero-inner">
            <div className="col-lg-7" data-aos="fade-up" data-aos-duration="1000">
              <p className="lux-eyebrow">Tailored for You</p>
              <h1 className="text-white lux-hero-heading">
                Discover luxury &amp; elegance <br />
              </h1>
              <h3 className="lux-hero-sub">with our premier Limousine and rental service</h3>
              <p className="lux-hero-body">
                Welcome to Eleego Limousine and Rental Service, where
                luxury meets convenience. Whether you are looking for a
                luxurious limousine for a special occasion or a rental car
                for travel, Eleego has you covered.
              </p>
              <div className="lux-hero-btns">
                <Link to={routes.contact} className="btn lux-btn-gold">Contact Us</Link>
              </div>
            </div>
          </div>
        </div>
        
        {/* Animated Circular Badge */}
        <div className="lux-hero__badge">
          <svg viewBox="0 0 100 100">
            <defs>
              <path id="circlePath" d="M 50, 50 m -37, 0 a 37,37 0 1,1 74,0 a 37,37 0 1,1 -74,0" />
            </defs>
            <text fontSize="10.5" fill="var(--luxury-gold)" letterSpacing="2">
              <textPath href="#circlePath">
                ELEEGO LUXURY • EST 2023 • ELEEGO LUXURY • EST 2023 •
              </textPath>
            </text>
          </svg>
          <div className="lux-hero__badge-icon">
            <i className="fa-solid fa-arrow-down" />
          </div>
        </div>
      </div>
      {/* /Banner */}

      {/* Premium Service Showcase */}
      <section className="lux-services-showcase">
        {/* Rent a Car — Image Left, Text Right */}
        <div className="lux-split lux-split--left">
          <div
            className="lux-split__image"
            style={{ backgroundImage: 'url(/assets/img/rent-a-car.jpg)' }}
          >
            <div className="lux-split__overlay" />
          </div>
          <div className="lux-split__content" data-aos="fade-left" data-aos-duration="900">
            <span className="lux-split__label">Our Services</span>
            <h2 className="lux-split__title">Rent a Car</h2>
            <div className="lux-split__divider" />
            <p className="lux-split__desc">
              Explore our premium fleet of rental vehicles — from sleek sedans to
              spacious SUVs — crafted for comfort, prestige, and freedom on the road.
            </p>
            <Link to={`${routes.listinggrid}?category=rental`} className="btn lux-btn-gold mt-3">
              Explore Rentals
            </Link>
          </div>
        </div>

        {/* Limousine Service — Image Right, Text Left */}
        <div className="lux-split lux-split--right">
          <div className="lux-split__content" data-aos="fade-right" data-aos-duration="900">
            <span className="lux-split__label">Our Services</span>
            <h2 className="lux-split__title">Limousine Service</h2>
            <div className="lux-split__divider" />
            <p className="lux-split__desc">
              Arrive in unmatched elegance. Our chauffeur-driven limousine service
              delivers an exceptional experience for events, airport transfers, and
              corporate travel.
            </p>
            <Link to={`${routes.listinggrid}?category=limousine`} className="btn lux-btn-gold mt-3">
              Explore Limousines
            </Link>
          </div>
          <div
            className="lux-split__image"
            style={{ backgroundImage: 'url(/assets/img/limousine.png)' }}
          >
            <div className="lux-split__overlay" />
          </div>
        </div>
      </section>
      {/* /Premium Service Showcase */}

      {/* services */}
      <section className="section services">
        <div className="service-right">
          <ImageWithBasePath
            src="assets/img/bg/service-right.svg"
            className="img-fluid"
            alt="services right"
          />
        </div>
        <div className="container">
          {/* Heading title*/}
          <div className="section-heading" data-aos="fade-down">
            <h2>The booking process</h2>
            <p>Booking a car with us is quick and easy</p>
          </div>
          {/* /Heading title */}
          <div className="services-work">
            <div className="row">
              <div className="col-lg-4 col-md-4 col-12" data-aos="fade-down">
                <div className="services-group">
                  <div className="services-icon border-secondary">
                    <ImageWithBasePath
                      className="icon-img bg-secondary"
                      src="assets/img/icons/services-icon-01.svg"
                      alt="Choose Locations"
                    />
                  </div>
                  <div className="services-content">
                    <h3>1. Choose a vehicle</h3>
                    <p>
                      Browse our selection of cars and pick the one that suits
                      your needs.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-12" data-aos="fade-down" data-aos-delay="150">
                <div className="services-group">
                  <div className="services-icon border-warning">
                    <ImageWithBasePath
                      className="icon-img bg-warning"
                      src="assets/img/icons/services-icon-02.svg"
                      alt="Choose Locations"
                    />
                  </div>
                  <div className="services-content">
                    <h3>2. Validate details</h3>
                    <p>
                      Enter your personal and rental details to confirm
                      everything is correct.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-12" data-aos="fade-down" data-aos-delay="300">
                <div className="services-group">
                  <div className="services-icon border-dark">
                    <ImageWithBasePath
                      className="icon-img bg-dark"
                      src="assets/img/icons/services-icon-03.svg"
                      alt="Choose Locations"
                    />
                  </div>
                  <div className="services-content">
                    <h3>3. Book your vehicle</h3>
                    <p>
                      Complete your booking and get ready to enjoy your ride!
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* /services */}
      {/* Popular Services */}

      {/* /Facts By The Numbers */}

      {/* Why Choose Us */}
      <section className="section why-choose popular-explore">
        <div className="choose-left">
          <ImageWithBasePath
            src="assets/img/bg/choose-left.png"
            className="img-fluid"
            alt="Why Choose Us"
          />
        </div>
        <div className="container">
          {/* Heading title*/}
          <div className="section-heading" data-aos="fade-down">
            <h2>Why Choose Us</h2>
            <p>
              With Reliable cars, great prices, and top-notch service your
              perfect ride awaits!
            </p>
          </div>
          {/* /Heading title */}
          <div className="why-choose-group">
            <div className="row">
              <div
                className="col-lg-4 col-md-6 col-12 d-flex"
                data-aos="fade-down"
              >
                <div className="card flex-fill">
                  <div className="card-body">
                    <div className="choose-img choose-black">
                      <ImageWithBasePath
                        src="assets/img/icons/bx-selection.svg"
                        alt=""
                      />
                    </div>
                    <div className="choose-content">
                      <h4>Easy Booking Process</h4> {/*&amp;*/}
                      <p>
                        Our simple and straightforward booking process allows
                        you to reserve your car quickly and efficiently, saving
                        you time and effort.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-lg-4 col-md-6 col-12 d-flex"
                data-aos="fade-down"
              >
                <div className="card flex-fill">
                  <div className="card-body">
                    <div className="choose-img choose-secondary">
                      <ImageWithBasePath
                        src="assets/img/icons/bx-crown.svg"
                        alt=""
                      />
                    </div>
                    <div className="choose-content">
                      <h4>Flexible Rental Options</h4>
                      <p>
                        Whether you need a car for a day, a week, or longer, we
                        offer flexible rental periods to suit your schedule.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-lg-4 col-md-6 col-12 d-flex"
                data-aos="fade-down"
              >
                <div className="card flex-fill">
                  <div className="card-body">
                    <div className="choose-img choose-primary">
                      <ImageWithBasePath
                        src="assets/img/icons/bx-user-check.svg"
                        alt=""
                      />
                    </div>
                    <div className="choose-content">
                      <h4>Excellent Customer Service</h4>
                      <p>
                        Our friendly and knowledgeable team is here to assist
                        you every step of the way, ensuring a smooth and
                        hassle-free rental experience.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* /Why Choose Us */}
      {/* About us Testimonials */}
      <section className="section about-testimonial testimonials-section">
        <div className="container">
          <div className="section-heading" data-aos="fade-down">
            <h2 className="title text-white">Customer Testimonials</h2>
            <p className="description text-white">
              Discover why our customers love us! Read what others have to say
              about their experiences with our car rental services.
            </p>
          </div>
          <div className="owl-carousel about-testimonials testimonial-group mb-0 owl-theme">
            <Slider {...settings}>
              {testimonials.map((testimonial) => (
                <div key={testimonial.id} className="testimonial-item d-flex">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <div className="quotes-head" />
                      <div className="review-box">
                        <div className="review-details">
                          <h6>{testimonial.name}</h6>
                        </div>
                      </div>
                      <p>{testimonial.review}</p>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </section>
      {/* About us Testimonials */}
      {/* FAQ  */}
      <section className="section faq-section bg-light-primary">
        <div className="container">
          {/* Heading title*/}
          <div className="section-heading" data-aos="fade-down">
            <h2>Frequently Asked Questions </h2>
            <p>
              Find answers to common questions about our car rental services,
              policies, and more to make your experience with us seamless and
              straightforward.
            </p>
          </div>
          {/* /Heading title */}
          <div className="faq-info">
            <div className="faq-card bg-white" data-aos="fade-down">
              <h4 className="faq-title">
                <Link
                  className="collapsed"
                  data-bs-toggle="collapse"
                  to="#faqOne"
                  aria-expanded="false"
                >
                  What is about eleego?
                </Link>
              </h4>
              <div id="faqOne" className="card-collapse collapse">
                <p>
                  Located in Geneva, Switzerland, and established in 2023, our
                  company has quickly become a premier choice for customers
                  seeking top-quality transportation solutions at an affordable
                  rate. At Eleego, we are dedicated to giving our customers a
                  luxury, convenient, and unforgettable transportation
                  experience by ensuring our guests make memories that will last
                  for a lifetime.
                </p>
              </div>
            </div>
            <div className="faq-card bg-white" data-aos="fade-down">
              <h4 className="faq-title">
                <Link
                  className="collapsed"
                  data-bs-toggle="collapse"
                  to="#faqTwo"
                  aria-expanded="false"
                >
                  In which areas do you operate?
                </Link>
              </h4>
              <div id="faqTwo" className="card-collapse collapse">
                <p>
                  At Eleego Limousine and Rental Service, we offer a range of
                  premium transportation solutions tailored to meet your needs:
                </p>
                <p>
                  <b>Limousine Services:</b> Our luxurious limousine services
                  are perfect for special occasions, business trips, airport
                  transfers, and city tours. Enjoy the comfort and elegance of
                  our well-maintained fleet, driven by professional chauffeurs
                  dedicated to providing you with a first-class experience
                </p>
                <p>
                  <b>Car Rentals:</b> For those who prefer to drive themselves,
                  we offer a selection of high-quality rental cars. From sleek
                  sedans to spacious SUVs, our rental fleet is designed to cater
                  to your specific travel requirements. Whether you&apos;re
                  exploring Geneva or embarking on a longer journey, our rental
                  cars provide the freedom and flexibility you need.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* /FAQ */}
      {/* Pricing Plan */}
      {/* <section className="pricing-section pricing-page pricing-section-bottom">
        <div className="container">
          <div className="user-app-group">
            <div className="app-left">
              <ImageWithBasePath
                src="assets/img/bg/app-left.png"
                className="img-fluid"
                alt="App Available"
              />
            </div>
            <div className="app-right">
              <ImageWithBasePath
                src="assets/img/bg/app-right.png"
                className="img-fluid"
                alt="App Available"
              />
            </div>
            <div className="row">
              <div className="col-lg-7">
                <div className="userapp-heading">
                  <h2 data-aos="fade-down">
                    Dreamsrental User Friendly App Available
                  </h2>
                  <p data-aos="fade-down">
                    Appropriately monetize one-to-one interfaces rather than
                    cutting-edge Competently disinte rmediate backward.
                  </p>
                  <div className="download-btn">
                    <div className="app-avilable" data-aos="fade-down">
                      <Link to="#">
                        <ImageWithBasePath
                          src="assets/img/play-store.svg"
                          alt="PlayStore"
                        />
                      </Link>
                    </div>
                    <div className="app-avilable" data-aos="fade-down">
                      <Link to="#">
                        <ImageWithBasePath
                          src="assets/img/apple.svg"
                          alt="AppStore"
                        />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-5 d-none d-lg-block">
                <div className="car-holder">
                  <ImageWithBasePath
                    className="app-car img-fluid"
                    src="assets/img/app-car.png"
                    alt="App Available"
                    data-aos="fade-down"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      {/* /Pricing Plan */}
    </>
  );
};

export default Home;
